import _ from 'lodash';
import { StoreType } from '../../../enuns/store.enun';

import api from '../../api';
import worldMap from '../../core/map';
import halo from '../../core/map/halo';
import environment from '../../environment';

import CustomersAction from './CustomersAction';
import HideAction from './HideAction';
import RoutingAction from './RoutingAction';
import ServiceAreaAction from './ServiceAreaAction';
import StreetViewAction from './StreetViewAction';
import ProtectAreaAction from './ProtectAreaAction';
import { FeaturePermission } from '../../../constants/feature.permission.helper';
import ServiceAreaAfterSalesAction from './ServiceAreaAfterSalesAction';
import { Network } from '../../../enuns/AfterSales/network';

const LayerControls = name => require('../../controls/index').get(name);

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

class HaloLayer {
    constructor(currentMap, layer, feature, name, context) {
        const id = currentMap._id;
        if (halo.hasBubbles(feature.properties.Id, currentMap)) {
            return;
        }

        if (worldMap.getCurrent()._id !== id) {
            worldMap.get().set(id);
        }

        const options = {
            id,
            context,
            feature,
            layer,
            currentMap,
            name,
        };

        this.layerActions = [];

        //Checking Authorizations for Layers that uses PIN Menus.
        this.checkDealershipsAndCompetitorsAuthorization(id, feature, name, options);
        this.checkGreenfieldAuthorization(feature, name, options);
        this.checkNewGreenfieldAuthorization(feature, name, options);
        this.checkBrownfieldAuthorization(feature, name, options);
        this.checkPointsOfInterestAuthorization(id, feature, name, options);

        this.layerActions.push(new StreetViewAction(options));

        const isAfterSales = environment.get('CONFIG.IS_AFTER_SALES');
        if (!isAfterSales ||
            _.some(['MulticriteriaAfterSales'], d => name === d) ||
            _.some(['DealershipAfterSales'], d => name === d) ||
            _.some(['NetworkAfterSales'], d => name === d) ||
            _.some(['CompetitorsAfterSales'], d => name === d) ||
            _.some(['PointOfInterest'], d => name === d)) {
            this.layerActions.push(new HideAction(options));
        }

        if (isAfterSales) {
            options.isAfterSales = true;
            this.layerActions.push(new RoutingAction(options));

            if (_.some(['NetworkAfterSales'], d => name === d) && isAuthorized(FeaturePermission.MAP_STORE.showClients)) {
                this.layerActions.push(new CustomersAction(options));
            }

            if (!_.some(['PointOfInterest', 'MulticriteriaAfterSales'], d => name === d)
                && ((_.some(['NetworkAfterSales'], d => name === d) && isAuthorized(FeaturePermission.LAYER_AFTER_SALES_NETWORK.showProtectArea))
                    || (_.some(['CompetitorsAfterSales'], d => name === d) && isAuthorized(FeaturePermission.LAYER_AFTER_SALES_NETWORK.showProtectArea))
                    || (_.some(['DealershipAfterSales'], d => name === d) && isAuthorized(FeaturePermission.LAYER_AFTER_SALES_DEALERSHIP.showProtectArea)))) {
                this.layerActions.push(new ProtectAreaAction(options));
            }

            if (_.some(['NetworkAfterSales'], d => name === d) && isAuthorized(FeaturePermission.LAYER_AFTER_SALES_NETWORK.showServiceArea)) {
                if (options.feature.properties.NetworkId === Network.Distributor) {
                    this.layerActions.push(new ServiceAreaAfterSalesAction(options));
                }
            }
        }

        const pinSize = LayerControls(name).getControls(id).radio[`pinSize${name}`].value;

        const radius = pinSize === 'large' ? 42 : 38;
        const offset = pinSize === 'large' ? [0, 35] : [0, 30];

        halo.create(this.layerActions, {
            radius,
            offset
        });
    }

    checkDealershipsAndCompetitorsAuthorization(id, feature, name, options) {
        if (_.some(['Dealerships', 'Competitors', 'UnapprovedStores'], d => name === d)) {
            // if (isAuthorized(FeaturePermission.MAP_STORE.reportChange))
            //     this.layerActions.push(new ReportAction(options));

            if (isAuthorized(FeaturePermission.MAP_STORE.route)) this.layerActions.push(new RoutingAction(options));

            if (isAuthorized(FeaturePermission.MAP_STORE.showClients) && name !== 'Competitors' && name !== 'UnapprovedStores') {
                if (!_.some([StoreType.TwoS], t => t.toUpperCase() === String(feature.properties.Tipo).toUpperCase())) {
                    this.layerActions.push(new CustomersAction(options));
                }
            }
            if (HaloLayer._hasServiceArea(id, feature, FeaturePermission.MAP_STORE.influenceArea) && name !== 'UnapprovedStores') {
                this.layerActions.push(new ServiceAreaAction(options));
            }

            if (_.some(['UnapprovedStores'], d => name === d) && isAuthorized(FeaturePermission.LAYER_UNAPPROVED_STORES.showProtectArea)) {
                this.layerActions.push(new ProtectAreaAction(options));
            }
        }
    }

    checkGreenfieldAuthorization(feature, name, options) {
        if (_.some(['Greenfield'], d => name === d)) {
            if (isAuthorized(FeaturePermission.MAP_GREENFIELD.route))
                this.layerActions.push(new RoutingAction(options));
        }
    }

    checkNewGreenfieldAuthorization(feature, name, options) {
        if (_.some(['NewGreenfield'], d => name === d)) {
            if (isAuthorized(FeaturePermission.MAP_NEW_GREENFIELD.route))
                this.layerActions.push(new RoutingAction(options));
        }
    }

    checkBrownfieldAuthorization(feature, name, options) {
        if (_.some(['Brownfield'], d => name === d)) {
            if (isAuthorized(FeaturePermission.MAP_BROWNFIELD.route))
                this.layerActions.push(new RoutingAction(options));
        }
    }

    checkPointsOfInterestAuthorization(id, feature, name, options) {
        if (_.some(['PointOfInterest'], d => name === d)) {
            if (isAuthorized(FeaturePermission.MAP_POINT_INTEREST.route))
                this.layerActions.push(new RoutingAction(options));
        }
    }

    static _hasServiceArea(id, feature, permission) {
        try {
            if (LayerControls('ServiceArea').getControls(id)) {
                if (isAuthorized(permission, feature)) {
                    return true;
                }
            }
            return false;
        } catch (err) {
            console.log(err);
        }
    }
}

export default HaloLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/HaloLayer/index.js